import { jsx as _jsx } from "react/jsx-runtime";
import { SnackbarProvider, useSnackbar } from "notistack";
import { createRef } from "react";
import { CloseIcon } from "../icons";
import { ToastContent } from "./ToastContent";
const Components = {
    info: ToastContent,
    success: ToastContent,
    error: ToastContent,
    warning: ToastContent,
    other: ToastContent,
};
export const ToastProvider = ({ children }) => {
    const providerRef = createRef();
    return (_jsx(SnackbarProvider, { maxSnack: Infinity, children: children, Components: Components, TransitionProps: { direction: "up" }, ref: providerRef }));
};
export const useToast = () => {
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const action = (key, variant) => {
        return (_jsx("button", { onClick: () => {
                closeSnackbar(key);
            }, children: _jsx(CloseIcon, { className: variant === "error"
                    ? "!fill-text-primary dark:!fill-text-primary-darkmode"
                    : "!fill-text-subdued-darkmode", size: "sm" }) }));
    };
    const showToast = (message, options) => {
        enqueueSnackbar(message, Object.assign(Object.assign({}, options), { variant: (options === null || options === void 0 ? void 0 : options.variant) || "info", 
            // @ts-expect-error we are overriding `action` to pass along the variant
            action, autoHideDuration: (options === null || options === void 0 ? void 0 : options.variant) === "error" ? 10000 : 5000 }));
    };
    const hideToast = (key) => {
        closeSnackbar(key);
    };
    return {
        showToast,
        hideToast,
    };
};
//# sourceMappingURL=Toast.js.map